export default __webpack_public_path__ + "static/media/video_2.932a6a6e.m4v";